import React from 'react';
import styled from 'styled-components/macro';
import Button from 'jsx/elements/buttons/Button';

import { api } from 'api';
import Spinner from 'jsx/elements/spinner';
import useLocale from 'jsx/locale/useLocale';

import { ApplicationTable } from './ApplicationTable';
import { useAuthContext } from 'jsx/auth/AuthProviderV2';
import { useHistory } from 'react-router';

export const ApplicationList = () => {
  const { t } = useLocale();
  const { user } = useAuthContext();
  const [data, setData] = React.useState(null);
  const history = useHistory();
  React.useEffect(() => {
    api.getMyApplications().then(data => setData(data));
  }, []);
  // console.log('data', data);
  if (!data) return <Spinner center size="medium" />;

  return (
    <>
      <h2 className="text-gray-dark text-28">Frysting lána - Umsóknir</h2>

      <div
        className="gutter-top"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      ></div>
      <div className="gutter-top"></div>

      <h3>Umsóknir til {user.s_name}</h3>
      <ApplicationTable
        applications={data}
        onClick={id => history.push(`/umsoknir/umsokn/${id}`)}
      />
    </>
  );
};
